/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.30/esri/copyright.txt for details.
*/
import{NoParameters as e}from"../../core/shaderModules/interfaces.js";class s extends e{}export{s as SMAAPassParameters};
